import { render, staticRenderFns } from "./requisitar-cirurgia.vue?vue&type=template&id=1a8a1ea5&scoped=true"
import script from "./requisitar-cirurgia.vue?vue&type=script&lang=js"
export * from "./requisitar-cirurgia.vue?vue&type=script&lang=js"
import style0 from "./requisitar-cirurgia.vue?vue&type=style&index=0&id=1a8a1ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a1ea5",
  null
  
)

export default component.exports